var $a8be062dce739a7d$exports = {};
$a8be062dce739a7d$exports = {
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`
};


export {$a8be062dce739a7d$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
